import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useSnackbar } from "notistack";

import MaterialTable from "material-table";

import extededFormStyles from "../../../assets/jss/material-dashboard-pro-react/views/extendedFormsStyle";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import CardHeader from "../../../components/Card/CardHeader";
import CardText from "../../../components/Card/CardText";
import ClientSearchComponent from "../../../components/ClientSearch";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import { isEmpty } from "../../../utils/barrels/lodash";
import {
	FormControlLabel,
	Switch,
	makeStyles,
} from "../../../utils/barrels/material-ui-core";
import {
	FirstPage,
	LastPage,
	SkipNext,
	SkipPrevious,
} from "../../../utils/barrels/material-ui-icons";
import { readCookie, scrollToElement } from "../../../utils/functions";

const styles = {
	extededFormStyles,
	cardCategoryWhite: {
		color: "rgba(255,255,255,.62)",
		margin: "0",
		fontSize: "14px",
		marginTop: "0",
		marginBottom: "0",
	},
	cardTitleWhite: {
		color: "#FFFFFF",
		marginTop: "0px",
		minHeight: "auto",
		fontWeight: "300",
		fontFamily: "inherit",
		marginBottom: "3px",
		textDecoration: "none",
	},
	alignCenter: {
		textAlign: "center",
	},
	deliveryPartner: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
	},
	dpImage: {
		width: "48px",
		height: "48px",
		marginRight: "16px",
		borderRadius: "4px",
	},
};

const useStyles = makeStyles(styles);
const useExtendedFormStyles = makeStyles(extededFormStyles);
const tableRef = React.createRef();

export default function DisableCarriers(props) {
	const classes = useStyles();
	const extendedClasses = useExtendedFormStyles();
	const [userCarriers, setUserCarriers] = useState([]);
	const [isStaff, setIsStaff] = useState(false);
	const [clientValue, setClientValue] = useState({});

	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();

	const fetchUserCarrers = () => {
		props.setBackdrop(true);
		props.getUserCarriers(clientValue.id).then((data) => {
			setUserCarriers(data);
			props.setBackdrop(false);
		});
	};

	const createCarrierDisable = (id, client, flag) => {
		if (client) {
			props
				.createDisableCarrier({
					delivery_partner_id: id,
					client_id: client,
					status: flag,
				})
				.then(() => {
					enqueueSnackbar("Success", {
						variant: "success",
						autoHideDuration: 500,
					});
					fetchUserCarrers();
				});
		}
	};

	const userCarrierToggle = (val, id) => {
		if (clientValue.length === 0) {
			if (isStaff && Object.keys(clientValue).length === 0) {
				enqueueSnackbar("Please select Client", {
					variant: "error",
					autoHideDuration: 5000,
				});
				return;
			}
		}
		props.setBackdrop(true);
		const client = readCookie("client", true);
		const client_id = isStaff ? clientValue.id : client?.client_poc?.client?.id;
		createCarrierDisable(id, client_id, val);
	};

	useEffect(() => {
		scrollToElement("#app-header");
		const bearerToken = readCookie("bearer");
		if (bearerToken) {
			const client = readCookie("client", true);
			if (client) {
				fetchUserCarrers();
				setIsStaff(client.is_staff);
			}
		} else {
			props.setUser({ reAuth: true, showReAuthModal: true });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (clientValue.length !== 0) {
			fetchUserCarrers();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [clientValue]);

	const setClientID = (event, val) => {
		if (!isEmpty(val)) {
			setClientValue(val);
		} else {
			setClientValue({});
		}
	};

	return (
		<div>
			<GridContainer spacing={2}>
				<GridItem xs={12} sm={12} md={12}>
					<Card>
						<CardHeader color="primary" text>
							<CardText color="primary">
								<h4 className={classes.cardTitle}>{t("carrier_partners")}</h4>
							</CardText>
						</CardHeader>
						<CardBody />
						{isStaff && (
							<GridContainer>
								<GridItem xs={8} sm={8} md={8} />

								<GridItem xs={4} sm={4} md={4}>
									<ClientSearchComponent
										value={clientValue}
										onChange={setClientID}
										showClient_id
										isStaff={isStaff}
									/>
								</GridItem>
							</GridContainer>
						)}
						<MaterialTable
							icons={{
								FirstPage,
								LastPage,
								PreviousPage: SkipPrevious,
								NextPage: SkipNext,
							}}
							localization={{
								header: {
									actions: t("active"),
								},
							}}
							tableRef={tableRef}
							columns={[
								{
									title: t("carrier_name"),
									field: "name",
									sorting: false,
									searchable: false,
								},
								{
									title: t("carrier_logo"),
									field: "logo",
									render: (data) => (
										<div className={classes.deliveryPartner}>
											<img
												className={classes.dpImage}
												alt={data.logo}
												src={data.logo}
											/>
										</div>
									),
									sorting: false,
									searchable: false,
								},
								{
									title: t("active"),
									field: "active",
									sorting: false,
									searchable: false,
									render: (data) => (
										<FormControlLabel
											control={
												<Switch
													checked={!data.is_disable}
													onChange={(event) =>
														userCarrierToggle(event.target.checked, data.id)
													}
													classes={{
														switchBase: extendedClasses.switchBase,
														checked: extendedClasses.switchChecked,
														thumb: extendedClasses.switchIcon,
														track: extendedClasses.switchBar,
													}}
													name="is_disable"
													color="primary"
												/>
											}
										/>
									),
								},
							]}
							title=""
							options={{
								pageSize: 10,
								filtering: false,
								search: false,
								actionsColumnIndex: -1,
								toolbar: false,
								padding: "dense",
							}}
							isLoading={false}
							data={userCarriers}
						/>
					</Card>
				</GridItem>
			</GridContainer>
		</div>
	);
}
